<div class="filter-dialog">
  <div class="header">
    <h1>ФИЛЬТР</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">

      <pas-choise title="Тип оценки" [items]="periods" [formControlName]="'period'">
        <ng-template #name let-item>
          {{ item.name }}
        </ng-template>
      </pas-choise>

      <pas-choise title="Выбор года" [items]="years" [formControlName]="'year'">
        <ng-template #name let-item>
          {{ item.name }}
        </ng-template>
      </pas-choise>

      @if (period?.name === 'Квартальная') {
        <pas-choise title="Выбор квартала" [items]="quarters" [formControlName]="'quarter'">
          <ng-template #name let-item>
            {{ item.name }}
          </ng-template>
        </pas-choise>
      }

      <pas-multi-select3 [formControlName]="'organizationGroup'"
                         title="Группа учреждений"
                         [customDataService]="groupService"
                         customDialogMethod="apiGroupFilterlistGet"
                         type="radio"
                         [options]="{object:['OrganizationGroup'], pageSize: 1e6}"
      >
        <ng-template #listItem let-item>
          {{ item.name }}
        </ng-template>
        <ng-template #dialogList let-item>
          {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
        </ng-template>
      </pas-multi-select3>
    </form>

  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" [style]="{color: 'white'}" mat-button (click)="onApply()" [disabled]="!form.valid">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

